import { localStorageService, StorageKeys } from './storageService';

const MAX_REDIRECTS = 2;

type RedirectCounts = Record<string, number>;

const isRedirectCounts = (value: unknown): value is RedirectCounts =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

// Counts are keyed by user id so a brand-new account signing in on a browser that already spent the
// cap still gets nudged. Values stored before that scoping were a bare number with no user attached;
// discarding them costs an already-capped user a couple of extra nudges, whereas crediting them to
// whoever reads first would keep blocking the new accounts this scoping exists to unblock.
const readCounts = (): RedirectCounts => {
  const stored: unknown = localStorageService.get(StorageKeys.SUBSCRIPTION_REDIRECT_COUNT);

  return isRedirectCounts(stored) ? stored : {};
};

const countFor = (counts: RedirectCounts, userId: string): number => Number(counts[userId] ?? 0) || 0;

/** Whether the post-login redirect into the subscription wizard is still available for this user. */
export const canRedirectToSubscriptionFlow = (userId: string): boolean =>
  countFor(readCounts(), userId) < MAX_REDIRECTS;

export const recordSubscriptionRedirect = (userId: string): void => {
  const counts = readCounts();

  localStorageService.set(StorageKeys.SUBSCRIPTION_REDIRECT_COUNT, {
    ...counts,
    [userId]: countFor(counts, userId) + 1,
  });
};
